module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8609697ebefd2c0b9b8056b2af43cef5.gif";